import Container from 'components/atomic/atoms/container';
import Text from 'components/atomic/atoms/text';
import { typography, colorScales } from 'design-system';
import { formatMlsNumber } from './format-mls-info';

export interface MlsInfoProps {
  mlsNumber?: string | null;
  /** Feed the listing came from — decides the listing-number prefix. */
  providerId?: number | null;
  courtesyText?: string;
  buyerRepText?: string;
}

export function MlsInfo({ mlsNumber, providerId, courtesyText, buyerRepText }: MlsInfoProps) {
  const formattedMlsNumber = mlsNumber
    ? formatMlsNumber({ mlsNumber, providerId })
    : undefined;

  if (!formattedMlsNumber && !courtesyText && !buyerRepText) {
    return null;
  }

  const textStyles = {
    fontSize: { xs: typography.fontSize.md, md: typography.fontSize.lg },
    lineHeight: typography.lineHeight.relaxed,
    fontWeight: typography.fontWeight.regular,
    color: colorScales.primaryNav[900],
  };

  const hasPrimaryRow = Boolean(formattedMlsNumber || courtesyText);

  return (
    <Container data-testid="ui-mls-info">
      {hasPrimaryRow && (
        <Text
          component="p"
          data-testid="ui-mls-info-primary-row"
          sx={{ ...textStyles, margin: 0 }}
        >
          {formattedMlsNumber}
          {formattedMlsNumber && courtesyText ? ' ' : null}
          {courtesyText}
        </Text>
      )}
      {buyerRepText && (
        <Text component="p" sx={{ ...textStyles, margin: 0 }}>
          {buyerRepText}
        </Text>
      )}
    </Container>
  );
}
